module.exports = __webpack_public_path__ + "static/8-0e97a00ef655d46857811a2b7a24d5dc.png";